const AuditTrail = ({ className, isSelected = false }) => {
    const fillColor = (isSelected ? 'var(--forbrand-primary)' : '#111113')

    return (
        <div
            className={`${className} flex items-center justify-center w-[32px] h-[32px]`}
        >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.5767 12.61C18.5767 13 18.2667 13.32 17.88 13.32C17.4933 13.32 17.18 13.0067 17.1767 12.6167L17.15 10.3533L13.66 14.12C13.6033 14.1667 13.54 14.1967 13.4767 14.2233L13.4533 14.2933L13.3067 14.2667C13.1867 14.2767 13.0667 14.2533 12.9567 14.2L10.2733 13.6867L6.49667 17.42C6.21333 17.6533 5.79333 17.6067 5.56667 17.3167C5.34 17.03 5.38333 16.6133 5.66667 16.3833L9.47333 12.5033L9.48667 12.5167C9.68 12.3133 9.98667 12.2467 10.25 12.3767L13.06 12.83L16.1567 9.36667L13.58 9.39667C13.1933 9.39667 12.88 9.08333 12.8767 8.69333C12.8767 8.30333 13.1867 7.98333 13.5733 7.98333L18.5367 7.94333L18.5767 12.62V12.61Z" fill={fillColor} />
                <path d="M20.25 1.5C21.08 1.5 21.75 2.17333 21.75 3V22.5C21.75 23.3267 21.08 24 20.25 24H3.75C2.92333 24 2.25 23.3267 2.25 22.5V3C2.25 2.17333 2.92333 1.5 3.75 1.5H6V3H3.75V22.5H20.25V3H18V1.5H20.25ZM7.5 1.5V0H16.5V1.5H7.5Z" fill={fillColor} />
            </svg>

        </div>
    )
}

export default AuditTrail
